<template>
<div>
  <Post v-if="isDetailPage"></Post>
  <Posts v-else></Posts>
</div>
</template>
<script>
import config from '@/config/config'
import Posts from '@/components/pages/Posts'
import Post from '@/components/pages/Post'
import { Category } from '@/api'

export default {
  name: 'PostPageHandler',

  components: {
    Posts,
    Post,
  },

  metaInfo() {
    return {
      titleTemplate(titleChunk) {
        return titleChunk ? `${titleChunk} | ${config.siteName}` : config.siteName
      },
    }
  },

  data(){
    return {
    }
  },

  computed: {
    isDetailPage() {
      return this.$route.query.id != null
    },
  },

  async created() {
    await this.setCategories()
  },

  methods: {
    async setCategories() {
      let params = { withChildren: 1 }
      //this.$store.dispatch('setLoading', true)
      try {
        const res = await Category.get(this.serviceId, 'root', params)
        if (this.checkObjHasProp(res, 'children')) {
          this.$store.dispatch('setCategories', res.children)
        }
        //this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err);//!!!!!!
        //this.$store.dispatch('setLoading', false)
      }
    },
  },
}
</script>

